module.exports = __webpack_public_path__ + "medina_railroad_museum.82b385318199d8c777b629cac80cda7e.png";